module.exports = __webpack_public_path__ + "static/media/pluto.cc961258.svg";